// extracted by mini-css-extract-plugin
export var cardLayout = "_9j-1";
export var paginationContainer = "_9j-0";